type ValueTrackerLogoProps = {
  size?: 'small' | 'large';
};

const getHeight = (size: 'small' | 'large') =>
  ({
    small: '32',
    large: '40'
  }[size]);

const getWidth = (size: 'small' | 'large') =>
  ({
    small: '34',
    large: '43'
  }[size]);

const ValueTrackerLogo = ({ size = 'small' }: ValueTrackerLogoProps) => {
  const height = getHeight(size);
  const width = getWidth(size);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 43 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.6221 0C40.2987 0 40.7577 0.689328 40.4988 1.31512L25.3657 37.7701C24.6764 39.4315 23.0707 40.502 21.2743 40.502C19.478 40.502 17.8722 39.4299 17.1829 37.7701L9.92294 20.2828C9.76093 19.892 9.20822 19.892 9.04621 20.2828L6.85757 25.5544C6.61298 26.1452 6.03643 26.5296 5.39636 26.5296H1.02067C0.344061 26.5296 -0.116538 25.8403 0.143938 25.2145L5.39318 12.5763C6.0809 10.9165 7.68665 9.84437 9.48299 9.84437C10.3819 9.84437 11.2333 10.1112 11.9448 10.5877C12.6564 11.0642 13.2297 11.7472 13.5744 12.5763L20.8344 30.062C20.9964 30.4527 21.5491 30.4527 21.7111 30.062L33.7867 0.975224C34.0313 0.384372 34.6079 0 35.248 0H39.6221Z"
        fill="#228BE6"
      />
      <path
        d="M39.6221 0C40.2987 0 40.7577 0.689328 40.4988 1.31512L25.3657 37.7701C24.6764 39.4315 23.0707 40.502 21.2743 40.502C19.478 40.502 17.8722 39.4299 17.1829 37.7701L9.92294 20.2828C9.76093 19.892 9.20822 19.892 9.04621 20.2828L6.85757 25.5544C6.61298 26.1452 6.03643 26.5296 5.39636 26.5296H1.02067C0.344061 26.5296 -0.116538 25.8403 0.143938 25.2145L5.39318 12.5763C6.0809 10.9165 7.68665 9.84437 9.48299 9.84437C10.3819 9.84437 11.2333 10.1112 11.9448 10.5877C12.6564 11.0642 13.2297 11.7472 13.5744 12.5763L20.8344 30.062C20.9964 30.4527 21.5491 30.4527 21.7111 30.062L33.7867 0.975224C34.0313 0.384372 34.6079 0 35.248 0H39.6221Z"
        fill="url(#paint0_linear_4623_69748)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4623_69748"
          x1="40.5056"
          y1="-7.45237"
          x2="17.3322"
          y2="49.3084"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.042983" stopColor="#FFD53D" />
          <stop offset="0.234544" stopColor="#D8F5A2" />
          <stop offset="0.319461" stopColor="#96F5B6" />
          <stop offset="0.464394" stopColor="#3BC9DB" />
          <stop offset="0.636407" stopColor="#228BE6" stopOpacity="0.5" />
          <stop offset="0.821163" stopColor="#228BE6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ValueTrackerLogo;
